<script type="text/javascript">

	import { onMount } from "svelte";
	import { get } from "svelte/store";
	import List, {Group, Item, Graphic, Meta, Label, Separator, Subheader, Text, PrimaryText, SecondaryText} from '@smui/list';

	import Sortable from "sortablejs/modular/sortable.core.esm.js";

	import MenuItem from "../FlyoutMenu/MenuItem.svelte";
	import Textfield, {Input, Textarea} from "@smui/textfield";
	import IconButton, {Icon} from "@smui/icon-button"
	import HelperText from "@smui/textfield/helper-text/index";
	import Menu, {SelectionGroup, SelectionGroupIcon} from "@smui/menu";
	import {Anchor} from "@smui/menu-surface";

	import AppStore from "../../AppStore";
	import MapStore from "../../Map/Store";
	import AuthStore from "../../Auth/Store";
	import MapLayer from "../../Map/Enums/MapLayer";

	import MySvelteTable from "../AlertList/MySvelteTable.svelte";
	import MeasureStore from "./Store";

	import RangeRingStore from "./RangeRing/Store";
	import RangeRingView from "./RangeRing/View.svelte";

	import RoutePlottingStore from "./RoutePlottingStore";

	import { CtrlKeyDown, ShiftKeyDown, AltKeyDown } from "../../Stores/userInput.js";

	import GeoHelper from "../../Helpers/GeoHelper";
	import roundFloat from "../../Helpers/Misc/roundFloat";

	import { onDestroy } from 'svelte';

	let map;

	let tableData = MeasureStore.inputs.tableData;

	let inputTime = MeasureStore.inputs.speedCalc.time;
	let inputSpeed = MeasureStore.inputs.timeCalc.speed;

	let resultTime = MeasureStore.results.time;
	let resultSpeed = MeasureStore.results.speed;

	let resultDistanceKM = MeasureStore.results.distance.km;
	let resultDistanceMiles = MeasureStore.results.distance.miles;
	let resultDistanceNauticalMiles = MeasureStore.results.distance.nauticalMiles;

	let rangeRings = RangeRingStore.items;
	$: if ($tableData.length > 0) {
		for(let i = 0; i < $rangeRings.length; i++) {
			$rangeRings[i].input.lng.set($tableData[0].lng);
			$rangeRings[i].input.lat.set($tableData[0].lat);
		}
	}


	let errorTime = MeasureStore.results.errs.time;
	let errorSpeed = MeasureStore.results.errs.speed;

	let onKeyUp = (e) => {
		if (e.key === "Enter") {
			onChange(e);
		}
	}
	let onChange = (e) => {
		const newValue = e.target.value;
		const index = e.target.dataset.index;
		console.log("val", newValue, "index", index);

		if (GeoHelper.isValidLngLat(newValue)) {
			// Set the coordinates on the table data.
			const lngLat = GeoHelper.parseStringLngLat(newValue);
			MeasureStore.actions.editPoint(index, {lng: lngLat[0], lat: lngLat[1]});

			const user = get(AuthStore.session.user);
			e.target.value = GeoHelper.lngLatCoordinatesToString(lngLat, user.lngLatFormat, 4);
		}
		else {
			// Reset the value to the start value.
			e.target.value = e.target.defaultValue;
		}
	};

	let lastUpdated = MeasureStore.meta.lastUpdated;
	let lastUpdatedRings = RangeRingStore.meta.lastUpdated;
	$: {
		$lastUpdated;
		setTimeout(() => {
			// Hack: (Re)bind change events to all text fields in the table.
			const results = [...document.querySelectorAll(".measure-latLngText")];
			for (var i = 0; i < results.length; i++) {
				const el = results[i];
				el.removeEventListener("keyup", onKeyUp);
				el.removeEventListener("focusout", onChange);
				el.addEventListener("keyup", onKeyUp);
				el.addEventListener("focusout", onChange);
			}
		}, 1);
	}

	$: {
		$tableData;
		$lastUpdated;
		$lastUpdatedRings;
		RangeRingStore.helpers.recalculateAll(); //
		MeasureStore.helpers.rebuildGeoJSON();
	}

	let movingPointIndex = -1;
	let onPointMove = (e) => {
		if (movingPointIndex >= 0) {
			MeasureStore.actions.editPoint(movingPointIndex, e.lngLat);
		}
	}

	let onUp = (e) => {
		movingPointIndex = -1;
		MeasureStore.actions.recalculateDistance();

		// Unbind mouse/touch events
		map.off('mousemove', onPointMove);
		map.off('touchmove', onPointMove);
	}

	MapStore.meta.initialised.subscribe((initialised) => {
		if (initialised) {
			map = MapStore.helpers.getMap();

			map.on('mouseenter', MapLayer.MEASURE_POINTS, (e) => {
		  		map.getCanvas().style.cursor = 'move';
			});
			map.on('mousemove', MapLayer.MEASURE_POINTS, (e) => {
				map.getCanvas().style.cursor = 'move';
			});
			map.on('mouseleave', MapLayer.MEASURE_POINTS, function() {
				map.getCanvas().style.cursor = MapStore.helpers.getDefaultCursor();
			});

			let mouseDown = (e) => {
				e.preventDefault();
				if (get(RoutePlottingStore.meta.visible)// && 
					//get(RoutePlottingStore.meta.activeTab) === "Measure"
					) 
				{
					if (movingPointIndex == -1 && e.features[0] != null) {
						const rs = MeasureStore.helpers.findClosestPointByLngLat(e.features[0].geometry.coordinates[0], e.features[0].geometry.coordinates[1]);
						if (rs != null) {
							movingPointIndex = rs;

							map.on('mousemove', onPointMove);
							map.on('touchmove', onPointMove);
							map.once('mouseup', onUp);
							map.once('touchend', onUp);
						}
					}
				}
			};
			map.on('mousedown', MapLayer.MEASURE_POINTS, mouseDown);
			map.on('touchstart', MapLayer.MEASURE_POINTS, mouseDown);

			// Map behaviours
			map.on('click', (e) => {
				if (get(RoutePlottingStore.meta.visible) && 
					get(RoutePlottingStore.meta.activeTab) === "Measure" && 
					e.type === "click") {
					if ($CtrlKeyDown) {
						MeasureStore.actions.addPointAt(e.lngLat.lng, e.lngLat.lat);
						e.preventDefault();
					}
					if ($AltKeyDown) {
						MeasureStore.actions.addPointBetweenAt(e.lngLat.lng, e.lngLat.lat);
						e.preventDefault();
					}
				}
			});
			map.on('contextmenu', MapLayer.MEASURE_POINTS, (e) => { // Right click
				const index = MeasureStore.helpers.findClosestPointByLngLat(e.lngLat.lng, e.lngLat.lat);
				if (index >= 0) {
					console.log('index', index);
					console.log('point', $tableData[index]);
					MeasureStore.actions.removePointByLngLat($tableData[index].lng, $tableData[index].lat);
				}
			});
		}
	});




	let measureContextMenu;
	let calculateContextMenu;

	let sortableLi;
	let sortable;
	onMount(()=>{
		sortable = new Sortable(sortableLi, {
			sort: true,
			draggable: ".mdc-list-item",
			handle: ".handle",
			onEnd: (evt) => {
				MeasureStore.actions.movePoint(evt.oldIndex, evt.newIndex);
			}
		});

	});

</script>

<style>
	img.icon {
		width: 16px;
		height: 16px;
	}

	.table-container table th.icon,
	.table-container table td.icon {
		width:45px;
	}
	.table-container {
		height:auto;
		padding-top: 0;
		padding-right: 0;
		overflow-y: scroll;
		overflow-x: hidden;
		resize: vertical;
		/*border: 2px solid #ccc;*/
		/*border-radius: 5px;*/
		margin-bottom: 5px;
	}
	.table-container table tr td img {
		height:16px;
	}

	.btn-clear {
		float:right;
		padding:8px;
		background-color:white;
		border-radius:2px;
		cursor:pointer;
	}
	.btn-add {
		float:right;
		margin-right:4px;
		padding:8px;
		background-color:white;
		border-radius:2px;
		cursor:pointer;
	}

	:global(input.measure-latLngText) {
		text-align: center !important;
		background-color: white !important;
		padding:10px;
		border:1px solid #ddd;
		margin-left:10px;
		margin-right:10px;
	}

	p.success {
		font-weight: bold;
		color: #28a745;
	}
	p.info {
		font-weight: bold;
		color: #007bff;
	}
	p.err {
		font-weight: bold;
		color: red;
	}

</style>

<MenuItem title={"Measure"} materialIcon={"square_foot"}>
	<div slot="context-menu">
		<IconButton class="material-icons" on:click={()=>{
			if ($tableData.length == 0) {
				MeasureStore.actions.addPoint();
			}
			else {
				measureContextMenu.setOpen(true);
			}
		}}>{#if $tableData.length == 0}add{:else}edit{/if}</IconButton>
		<div style="left:-115px;"> <!-- filthy hack! -->
			<Menu bind:this={measureContextMenu} anchorCorner="TOP_RIGHT">
				<List>
					<Item on:SMUI:action={MeasureStore.actions.addPoint}><Text>Add Point</Text></Item>
					<Item on:SMUI:action={MeasureStore.actions.clearAllPoints}><Text>Clear All</Text></Item>
				</List>
			</Menu>
		</div>
	</div>

	{#if $tableData.length == 0}
		<p>Add a point to get started...</p>
	{/if}

	<div class={"oa " + (($tableData.length > 0)?"mdc-elevation--z2":"") }>
		<ul class='striped-list mdc-list mdc-list--non-interactive' bind:this={sortableLi} role="list">
			{#each $tableData as row, n}
				<li class='mdc-list-item draggable' style="padding:5px;">
					<IconButton style="cursor:move;" class="material-icons handle" on:click={() => { console.log('click!'); }}>drag_indicator</IconButton>

					<input class='mdc-text-field__input measure-latLngText' type='text' data-index={n} value={row.lngLat}/>

					<IconButton class="material-icons" on:click={() => {
						console.log('click!');
						MeasureStore.actions.removePointByLngLat(row.lng, row.lat);
					}}>delete</IconButton>
				</li>
			{/each}
		</ul>
	</div>


	{#if $tableData.length > 1}
		<div>
			<p><b>Total Distance:</b></p>
			<ul>
				<li>{roundFloat($resultDistanceNauticalMiles, 2)} nautical miles</li>
				<li>{roundFloat($resultDistanceMiles, 2)} miles</li>
				<li>{roundFloat($resultDistanceKM, 3)} kilometers {#if $resultDistanceKM < 1}({parseInt($resultDistanceKM * 1000)} metres){/if}</li>
			</ul>
		</div>
	{/if}
</MenuItem>
<MenuItem title={"Calculate"} materialIcon={"functions"}>

	<div slot="context-menu" class='context-menu'>
		{#if $tableData.length == 1}
			<IconButton class="material-icons" on:click={()=>{calculateContextMenu.setOpen(true);}}>add</IconButton>
			<div style="left:-140px;"> <!-- filthy hack! -->
				<Menu bind:this={calculateContextMenu} anchorCorner="TOP_RIGHT">
					<List>
						<Item on:SMUI:action={RangeRingStore.actions.add}><Text>Add Range Ring</Text></Item>
						<Item on:SMUI:action={RangeRingStore.actions.clearAll}><Text>Clear All</Text></Item>
					</List>
				</Menu>
			</div>
		{/if}
	</div>


	<div>
		{#if $tableData.length == 0}
			<p class='info'>Add more points to perform calculations...</p>
		{:else if $tableData.length == 1}
			<div>
				{#each $rangeRings as rangeRing, n (rangeRing)}
					<RangeRingView data={rangeRing} on:change={	MeasureStore.helpers.onLineUpdated }/>
				{/each}
			</div>
		{:else}
			<div>
				<h2>Calculate speed (by time in minutes)</h2>
				<Textfield dense variant="filled" bind:value={$inputTime} label="Time (minutes)..." style="width:100%" />

				{#if $errorSpeed.length > 0}
					<p class="err"><b>Error: {$errorSpeed}</b></p>
				{:else if $resultSpeed.length > 0}
					<p class="success">Result: {$resultSpeed} </p>
				{/if}
			</div>
			<div>
				<h2>Calculate time (by speed in knots/nmph)</h2>
				<Textfield dense variant="filled" bind:value={$inputSpeed} label="Speed (knots/nmph)..." style="width:100%" />

				{#if $errorTime.length > 0}
					<p class="err"><b>Error: {$errorTime}</b></p>
				{:else if $resultTime.length > 0}
					<p class="success">Result: {$resultTime} </p>
				{/if}

			</div>
		{/if}

	</div>
</MenuItem>
